import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportChat } from './support-chat.model';

export interface GenerateSupportChatOptions {
  readonly id?: number;
  readonly userId: number;
  readonly issueCategoryId?: number;
}

export function generateSupportChatObject({
  id = generateId(),
  userId,
  issueCategoryId,
}: GenerateSupportChatOptions): SupportChat {
  return {
    id,
    userId,
    issueCategoryId,
  };
}
